import React from 'react';
import { NavLink } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import SidebarSteps from '../components/SidebarSteps';
// import useAuthRedirect from '../hooks/useAuthRedirect';
function SignUp3() {
   // useAuthRedirect();
   return (
      <div className="container" page-key="signup3">
         <div className="row">
            <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
               <span className="mt-auto d-lg-none">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
               </span>
               <DarkModeBtn />
            </div>
            <div className="col-12">
               <div className="d-flex flex-column align-items-center align-items-lg-start w-100 gap-2 mb-3">
                  <h1 className="d-lg-none">Sign Up</h1>
                  <SidebarSteps activeStep={2} />
               </div>
               <div className="ppt_signup_steps">
                  <div className="ppt_signup_steps_info text-center">
                     <img src={process.env.PUBLIC_URL + '/assets/img/icon_check.svg'} className="img-fluid mb-4 smallMeicon" alt="" style={{ maxWidth: 100 + 'px' }} />
                     <h3 className="ppt_form_title mb-5">Email confirmed</h3>
                     <NavLink to="/sign-up-4" className="ppt_btn_primary">Next</NavLink>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
export default SignUp3;